import React, { useState } from "react";
import { useGetSectorsQuery } from "../../../redux/service/modules/admin";
import PaginatedDataTable from "../../../components/table/PaginatedDataTable";
import Layout from "../../../components/layout/Layout";
import { CustomAdminLayout } from "../../../components/layout/CustomAdminLayout";
import SectorDialog from "./SectorDialog";
const SectorDetails = () => {
    const [open, setOpen] = useState(false);
    const [searchText, setSearchtext] = useState("");

    // Debounce function
    const debounce = (func, delay) => {
        let timeoutId;
        return (...args) => {
            if (timeoutId) clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                func(...args);
            }, delay);
        };
    };

    const handleSearch = debounce((value) => {
        setSearchtext(value);
    }, 500);
    return (
        <Layout>
            <CustomAdminLayout
                title={"Sector Details"}
                createButtonText={"Add New Sector"}
                createOnClick={() => {
                    setOpen(true);
                }}
                showSearchInput
                showCreateButton={true}
                onSearch={handleSearch}
                searchPlaceholder={"Search Sectors"}
            >
                <PaginatedDataTable
                    queryHook={useGetSectorsQuery}
                    title="Sector Management"
                    paginationEnabled={true}
                    showEditColumn={true}
                    showCheckboxColumn={false}
                    appliedFilters={{ search: searchText }}
                    dialogType={"sector"}
                />
                <SectorDialog
                    open={open}
                    onClose={() => setOpen(false)}
                    isEdit={false}
                    title={"Add New Sector"}
                    ctaText={"ADD SECTOR"}
                />
            </CustomAdminLayout>
        </Layout>
    );
};

export default SectorDetails;
